import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 0h415v90H0z",
  fill: "none"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.8 42.6c0-11.1 4.6-18.1 15.3-18.1 10.5 0 15.1 6.8 15.1 17.8 0 10.9-4.6 18.2-15.4 18.2-10.3 0-15-6.7-15-17.9zm21.9-.1c0-6.3-1-10.9-6.7-10.9s-6.7 4.6-6.7 10.9c0 6.2 1 10.9 6.7 10.9 5.7-.1 6.7-4.7 6.7-10.9zm16 11.3h8.6V39.9h-8.6v-6.1h8.6v-.1c0-10.4 9-13.6 18.1-13.6v6.1c-4.6 0-10 1.3-10 7.5v.1h10v6.1h-10v13.9h10v6.1H66.7v-6.1zm36 0h8.6V39.9h-8.6v-6.1h8.6v-.1c0-10.4 9-13.6 18.1-13.6v6.1c-4.6 0-10 1.3-10 7.5v.1h10v6.1h-10v13.9h10v6.1h-26.7v-6.1zm34.7-7.4c0-10.9 7.5-14 14.8-14 6.8 0 13.7 2.7 14.2 11.6h-8.2c-.3-3.8-2.6-5.1-6-5.1-4.1 0-6.5 2.1-6.5 7.4s2.3 7.4 6.5 7.4c3.3 0 5.6-1.3 5.9-5h8.2c-.5 8.8-7.6 11.6-14.3 11.6-7.1.2-14.6-3-14.6-13.9zm36 .1c0-11 7.8-14.1 14.8-14.1 7.1 0 14.5 3.2 14.5 13.9 0 11-7.8 14.2-14.8 14.2s-14.5-3.2-14.5-14zm20.9-.1c0-5.3-2.3-7.4-6.3-7.4s-6.3 2.1-6.3 7.4 2.3 7.4 6.3 7.4c4 .1 6.3-2 6.3-7.4zm17.1 3.3V33h8v15.2c0 3.8 1 5.5 4.2 5.5 2.2 0 3.7-.7 4.9-1.9V33h8v26.8h-7v-3.6c-1.3 2-4.1 4.2-8.6 4.2-4.9.1-9.5-2.4-9.5-10.7zm35.9 4.1h6.3V39.1h-6.3V33h13.4v5.8c1.3-3 3.7-6.4 8.9-6.4 2.6 0 4.4.8 5.3 1.5v7.9c-1.4-.9-3.2-1.7-5.7-1.7-1.9 0-4.7.5-7.6 3.4v10.3h11v6.1h-25.3v-6.1zm34.2-2.3h8.2c.2 2.6 2.9 3.3 6.5 3.3 3.1 0 5.9-.5 5.9-2.5 0-2.2-3.9-2.4-9.2-3.2-5.2-.8-10.9-2.2-10.9-8.2 0-5.9 5.6-8.5 13.7-8.5 7 0 12.7 1.9 13.1 8.5h-8.2c-.4-2.3-3-2.8-5.6-2.8-2.8 0-4.7.6-4.7 2.2 0 1.9 2.9 2.2 9.2 3.1 5.3.7 10.9 2.2 10.9 8.3 0 6.7-6.8 8.9-14.8 8.8-7.6-.1-13.9-2.2-14.1-9zm36-4.9c0-10.8 7.5-14.2 14.7-14.2 7.4 0 14.2 3.5 14.2 14v1.4h-20.8c0 3.8 1.9 6.6 6.8 6.6 3 0 5.2-1 5.6-2.9h8.3c-1.4 6.7-7.4 9-13.9 9-8.3 0-14.9-3.8-14.9-13.9zm20.7-3.7c-.8-3.4-3.5-4.4-6.2-4.4s-5.3 1-6.2 4.4h12.4zm13.1 16.9h33.4v7h-33.4v-7z",
  fill: "#fff"
});

var logoSvg = "data:image/svg+xml,%3Csvg%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20preserveAspectRatio%3D%22xMinYMax%20meet%22%20%20viewBox%3D%220%200%20415%2090%22%3E%20%20%3Cpath%20id%3D%22logo_basis%22%20d%3D%22M0%200h415v90H0z%22%20fill%3D%22none%22%20className%3D%22st0%22%20%2F%3E%20%20%3Cpath%20%20%20%20id%3D%22Typography%22%20%20%20%20d%3D%22M28.8%2042.6c0-11.1%204.6-18.1%2015.3-18.1%2010.5%200%2015.1%206.8%2015.1%2017.8%200%2010.9-4.6%2018.2-15.4%2018.2-10.3%200-15-6.7-15-17.9zm21.9-.1c0-6.3-1-10.9-6.7-10.9s-6.7%204.6-6.7%2010.9c0%206.2%201%2010.9%206.7%2010.9%205.7-.1%206.7-4.7%206.7-10.9zm16%2011.3h8.6V39.9h-8.6v-6.1h8.6v-.1c0-10.4%209-13.6%2018.1-13.6v6.1c-4.6%200-10%201.3-10%207.5v.1h10v6.1h-10v13.9h10v6.1H66.7v-6.1zm36%200h8.6V39.9h-8.6v-6.1h8.6v-.1c0-10.4%209-13.6%2018.1-13.6v6.1c-4.6%200-10%201.3-10%207.5v.1h10v6.1h-10v13.9h10v6.1h-26.7v-6.1zm34.7-7.4c0-10.9%207.5-14%2014.8-14%206.8%200%2013.7%202.7%2014.2%2011.6h-8.2c-.3-3.8-2.6-5.1-6-5.1-4.1%200-6.5%202.1-6.5%207.4s2.3%207.4%206.5%207.4c3.3%200%205.6-1.3%205.9-5h8.2c-.5%208.8-7.6%2011.6-14.3%2011.6-7.1.2-14.6-3-14.6-13.9zm36%20.1c0-11%207.8-14.1%2014.8-14.1%207.1%200%2014.5%203.2%2014.5%2013.9%200%2011-7.8%2014.2-14.8%2014.2s-14.5-3.2-14.5-14zm20.9-.1c0-5.3-2.3-7.4-6.3-7.4s-6.3%202.1-6.3%207.4%202.3%207.4%206.3%207.4c4%20.1%206.3-2%206.3-7.4zm17.1%203.3V33h8v15.2c0%203.8%201%205.5%204.2%205.5%202.2%200%203.7-.7%204.9-1.9V33h8v26.8h-7v-3.6c-1.3%202-4.1%204.2-8.6%204.2-4.9.1-9.5-2.4-9.5-10.7zm35.9%204.1h6.3V39.1h-6.3V33h13.4v5.8c1.3-3%203.7-6.4%208.9-6.4%202.6%200%204.4.8%205.3%201.5v7.9c-1.4-.9-3.2-1.7-5.7-1.7-1.9%200-4.7.5-7.6%203.4v10.3h11v6.1h-25.3v-6.1zm34.2-2.3h8.2c.2%202.6%202.9%203.3%206.5%203.3%203.1%200%205.9-.5%205.9-2.5%200-2.2-3.9-2.4-9.2-3.2-5.2-.8-10.9-2.2-10.9-8.2%200-5.9%205.6-8.5%2013.7-8.5%207%200%2012.7%201.9%2013.1%208.5h-8.2c-.4-2.3-3-2.8-5.6-2.8-2.8%200-4.7.6-4.7%202.2%200%201.9%202.9%202.2%209.2%203.1%205.3.7%2010.9%202.2%2010.9%208.3%200%206.7-6.8%208.9-14.8%208.8-7.6-.1-13.9-2.2-14.1-9zm36-4.9c0-10.8%207.5-14.2%2014.7-14.2%207.4%200%2014.2%203.5%2014.2%2014v1.4h-20.8c0%203.8%201.9%206.6%206.8%206.6%203%200%205.2-1%205.6-2.9h8.3c-1.4%206.7-7.4%209-13.9%209-8.3%200-14.9-3.8-14.9-13.9zm20.7-3.7c-.8-3.4-3.5-4.4-6.2-4.4s-5.3%201-6.2%204.4h12.4zm13.1%2016.9h33.4v7h-33.4v-7z%22%20%20%20%20fill%3D%22white%22%20%20%20%20className%3D%22st1%22%20%20%2F%3E%3C%2Fsvg%3E";

/**
 * @name Offcourse Theme
 * @description default styles for the Offcourse project
 */
var logo = {
  svg: logoSvg,
  dimensions: { height: 1, width: 4.66666 },
  background: "black"
};

var baseColors = {
  black: "#000000",
  white: "#FFFFFF",
  darkGray: "#3d3d3d",
  mediumGray: "#c0c4c1",
  lightGray: "#f4f6f4",
  yellow: "#E5CF39",
  blue: "#75C7B3",
  green: "#A5CC45",
  red: "#E34D2F"
};

var grayScale = [baseColors.white, baseColors.lightGray, baseColors.mediumGray, baseColors.darkGray, baseColors.black];

var namedGrayScale = grayScale.map(function (value, index) {
  var name = void 0;
  if (index === 0) {
    name = "white";
  } else if (index === grayScale.length - 1) {
    name = "black";
  } else {
    name = "gray[" + index + "]";
  }
  return { name: name, value: value };
});

var colors = {
  grayScale: grayScale,
  primary: baseColors.blue,
  disabled: grayScale[2],
  positive: baseColors.green,
  warning: baseColors.yellow,
  info: baseColors.blue,
  negative: baseColors.red,
  white: baseColors.white,
  black: baseColors.black
};

var fonts = {
  base: "Nitti Grotesk",
  bold: "Nitti Grotesk Bold",
  accent: "Nitti Bold"
};

var breakpoints = ["30rem", "48rem", "64rem"];

var baseUnit = 16;

var fontSizes = ["0.75rem", "1rem", "1.375rem", "1.75rem"];

var lineHeights = ["1rem", "1.25rem", "1.375rem", "1.75rem", "1.875rem"];

var space = [0, "0.0625rem", "0.125rem", "0.25rem", "0.5rem", "0.75rem", "1rem", "1.5rem", "2rem"];

var borders = [0, "0.0625rem solid", "0.125rem solid"];

var units = {
  sixteenth: "0.0625rem",
  eight: "0.125rem",
  quarter: "0.25rem",
  half: "0.5rem",
  threeQuarter: "0.75rem",
  base: baseUnit,
  baseFont: baseUnit,
  baseLine: "1.25rem",
  logoHeight: "1.875rem",
  subTitleFont: "1.375rem",
  titleFont: "1.75rem",
  titleHeight: "1.875rem"
};

var globals = "\n  body {\n    margin: 0;\n    padding: 0;\n    top: 0;\n    left: 0;\n    right: 0;\n    background: " + grayScale[1] + ";\n    overflow-x: hidden;\n  }\n\n  @font-face {\n    font-family: 'Nitti Grotesk';\n    src: url('https://app.offcourse.io/fonts/NGN.woff') format('woff');\n  }\n\n  @font-face {\n    font-family: 'Nitti Grotesk Bold';\n    src: url('https://app.offcourse.io/fonts/NGB.woff') format('woff');\n  }\n\n  @font-face {\n    font-family: 'Nitti Bold'; \n    src: url('https://app.offcourse.io/fonts/NB.woff') format('woff');\n  }\n\n  * {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n\n  body {\n    font-family: Nitti Grotesk;\n    font-size: 16px;\n    line-height: 20px;\n  }\n";

var theme = {
  mode: "default",
  breakpoints: breakpoints,
  fontSizes: fontSizes,
  lineHeights: lineHeights,
  logo: logo,
  space: space,
  colors: colors,
  borders: borders,
  units: units,
  fonts: fonts,
  grayScale: grayScale,
  globals: globals,
  namedGrayScale: namedGrayScale
};

var _ref$1 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 -90)"
}, React.createElement("defs", null, React.createElement("path", {
  id: "a",
  d: "M35 55h130v40H35z"
})), React.createElement("clipPath", {
  id: "b"
}, React.createElement("use", {
  xlinkHref: "#a",
  width: "100%",
  height: "100%",
  overflow: "visible"
})), React.createElement("g", {
  transform: "translate(-25 45)",
  clipPath: "url(#b)",
  className: "st3"
}, React.createElement("path", {
  d: "M165 77.6h-2.1c-.2.6-.4 1.4-.9 2.6-.4 1-.6 1.9-.7 2.7-.2-1-.3-1.5-.8-2.7-.4-1-.7-1.9-1-2.6h-2.1c.1.5.2.9 1.7 4.1.7 1.6 1 2.3 1.3 2.8-.2.4-.4.7-.7 1.4-.3.7-.5 1.1-.8 1.7h2.2c.3-1 .7-1.8 1.6-4.1 1.4-3.7 2.1-5.3 2.3-5.9m-8 1.8v-1.8c-.4.1-1.7 0-2.1.1.1-.6.1-1.1.1-1.7-.5.1-1.2.2-1.7.2 0 .4 0 1.3.1 1.5-.3-.1-1.2-.1-1.6-.1v1.8c.4 0 1.1 0 1.5-.2-.1.8-.2 2.5-.2 3.3 0 1.7.6 2.5 2.2 2.5.6 0 1.2-.1 1.6-.2 0-.3-.1-.6-.1-.9v-.7c-.2 0-.5.1-.8.1-1 0-1.2-.2-1.2-1.3 0-.8-.1-2.2-.2-2.6v-.1c.7.1 1.8.1 2.4.1m-7.9 1.3c-.5-.1-1-.1-1.6-.1-.6 0-1.2 0-1.7.1 0-1.2.6-1.7 1.7-1.7 1.2 0 1.6.5 1.6 1.7m1.8 1.2v-.6c0-2.8-1.2-4-3.3-4-2.2 0-3.5 1.6-3.5 3.9 0 2.4 1.5 3.9 3.8 3.9 1.1 0 2-.3 2.5-.7-.1-.4-.1-1.2-.1-1.5-.6.3-1.4.4-2.3.4-1.2 0-2-.5-2.1-1.6.2.1.8.1 1.4.1zm-8.4-4.3h-2c0 1.2.1 2.5.1 3.8v3.5h2v-3.5c-.2-1.3-.2-2.6-.1-3.8m.1-1.5v-1.8h-2.4v1.8h2.4m-3.6 2.1c-.5-.6-1.2-.8-2.1-.8-2.3 0-3.8 1.6-3.8 3.8 0 2.2 1.5 3.9 3.8 3.9.8 0 1.6-.3 2.1-.8-.1-.5-.2-1.2-.2-1.7-.5.4-1.1.6-1.8.6-1.3 0-2.1-.8-2.1-2.1 0-1.2.7-2 2.1-2 .9 0 1.3.2 1.9.7 0-.7 0-1.3.1-1.6m-8.9 3c0 1.3-.6 2.2-1.9 2.2-1.3 0-1.9-1-1.9-2.2 0-1.3.6-2.1 1.9-2.1 1.3-.1 1.9.7 1.9 2.1m1.8 0c0-2.4-1.5-3.9-3.6-3.9s-3.6 1.5-3.6 3.8c0 2.4 1.4 4 3.6 4 2.1.1 3.6-1.6 3.6-3.9m-8.6 1.5c0-1.2-.6-1.7-1.9-2-1.4-.3-1.5-.4-1.5-.8 0-.5.4-.8 1.4-.8.7 0 1.3.1 1.8.4 0-.6.1-1.2.2-1.6-.5-.4-1.3-.6-2.1-.6-2 0-3.1 1-3.1 2.4 0 1.1.5 1.8 2 2 1.3.2 1.4.3 1.4.8s-.3.8-1.2.8c-.7 0-1.3-.1-1.8-.4 0 .5-.1 1.1-.1 1.6.5.4 1.3.5 2 .5 1.8.1 2.9-.8 2.9-2.3m-11.5-3.1c0 .4-.1.9-.1 1.4v1.1c-.3.4-.7.6-1.5.6-1.1 0-1.7-.7-1.7-1.8s.5-1.8 1.7-1.8c.8.1 1.3.2 1.6.5m1.8-2h-1.4c-.1.2-.1.5-.2.9-.4-.7-.9-1.1-2-1.1-2 0-3.3 1.4-3.3 3.6 0 2 1.4 3.5 3.3 3.5.9 0 1.5-.6 1.8-1.2v.9c0 1.3-.6 1.8-1.9 1.8-.6 0-1.1-.1-1.6-.2 0 .5 0 1-.1 1.6.5.3 1.2.4 1.8.4 2.1 0 3.6-1.1 3.6-3.8v-6.4M103.4 83c-.3.4-.7.6-1.4.6-.8 0-1.1-.3-1.1-.8 0-.6.4-.8 1.3-.9.5 0 .9 0 1.1-.1zm2 1.9c-.1-.7-.2-1.3-.2-1.9v-2.7c0-2.1-1-3-3.1-3-1.2 0-2.1.3-2.6 1.1.1.4.2.9.2 1.5.4-.5 1.1-.8 2.3-.8 1.1 0 1.5.2 1.5 1.1v.4h-.4c-2.6 0-3.8.6-3.8 2.3 0 1.4.9 2.2 2.4 2.2 1.1 0 1.7-.5 2-1.4h.1c0 .4.1.8.2 1.2h1.4M96 83c-.3.4-.7.6-1.4.6-.8 0-1.1-.3-1.1-.8 0-.6.4-.8 1.3-.9.5 0 .9 0 1.1-.1zm1.9 1.9c-.1-.7-.2-1.3-.2-1.9v-2.7c0-2.1-1-3-3.1-3-1.2 0-2.1.3-2.6 1.1.1.4.2.9.2 1.5.4-.5 1.1-.8 2.3-.8 1.1 0 1.5.2 1.5 1.1v.4h-.4c-2.6 0-3.8.6-3.8 2.3 0 1.4.9 2.2 2.4 2.2 1.1 0 1.7-.5 2-1.4h.1c0 .4.1.8.2 1.2h1.4m-6.8-7.3h-1.9c-.1.7-.4 1.6-.6 2.5-.2 1-.5 2-.6 2.9-.1-.9-.5-2-.8-3.1-.4-1.1-.6-1.8-.8-2.2h-1.6c-.2.4-.4 1.1-.8 2.2-.4 1.2-.7 2.3-.8 3.1-.1-.8-.3-1.8-.6-2.9-.2-.9-.5-1.8-.6-2.5h-1.9c0 .3.3 1.4 1.2 4.1.5 1.4.8 2.4 1 3.2H84c.1-.3.7-1.7 1.1-2.9.3-.9.5-1.7.6-2.5.1.8.3 1.6.6 2.5.4 1.2 1 2.7 1.1 2.9h1.7c.2-.8.5-1.7 1-3.2.6-2.8 1-3.9 1-4.1",
  className: "st0",
  fill: "#1d1d1b"
})), React.createElement("g", {
  transform: "translate(-25 45)",
  clipPath: "url(#b)",
  className: "st3"
}, React.createElement("path", {
  d: "M55 95c11 0 20-8.9 20-20 0-11-8.9-20-20-20-11 0-20 8.9-20 20 0 11 9 20 20 20",
  className: "st0",
  fill: "#1d1d1b"
})), React.createElement("g", {
  transform: "translate(-25 45)",
  clipPath: "url(#b)",
  className: "st3"
}, React.createElement("path", {
  d: "M61.6 64.2l3.7 7.7 1.3 12.6h-7.5v-6.3c0-2.4-1.8-4.3-4.1-4.3s-4.1 2-4.1 4.3v6.3h-7.5l1.3-12.6 3.7-7.7 1.6 6.3 5.1-8.5 5.1 8.6z",
  fill: "#fff"
})));

var logoSvg$1 = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20id%3D%22Layer_1%22%20width%3D%22150%22%20height%3D%2260%22%3E%20%20%3Cg%20id%3D%22Link%3A_Waag_1_%22%20transform%3D%22translate%280%20-90%29%22%3E%20%20%20%20%3Cdefs%20id%3D%22defs3744%22%3E%20%20%20%20%20%20%3Cpath%20id%3D%22SVGID_1_%22%20d%3D%22M35%2055h130v40H35z%22%2F%3E%20%20%20%20%3C%2Fdefs%3E%20%20%20%20%3CclipPath%20id%3D%22SVGID_2_%22%3E%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23SVGID_1_%22%20id%3D%22use3746%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20overflow%3D%22visible%22%2F%3E%20%20%20%20%3C%2FclipPath%3E%20%20%20%20%3Cg%20id%3D%22g3775%22%20transform%3D%22translate%288.743%20-8.81%29%22%3E%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-33.743%2053.81%29%22%20id%3D%22g3751%22%20clip-path%3D%22url%28%23SVGID_2_%29%22%20class%3D%22st3%22%3E%20%20%20%20%20%20%20%20%3Cpath%20id%3D%22path3749%22%20d%3D%22M165%2077.6h-2.1c-.2.6-.4%201.4-.9%202.6-.4%201-.6%201.9-.7%202.7-.2-1-.3-1.5-.8-2.7-.4-1-.7-1.9-1-2.6h-2.1c.1.5.2.9%201.7%204.1.7%201.6%201%202.3%201.3%202.8-.2.4-.4.7-.7%201.4-.3.7-.5%201.1-.8%201.7h2.2c.3-1%20.7-1.8%201.6-4.1%201.4-3.7%202.1-5.3%202.3-5.9m-8%201.8v-.8-1c-.4.1-1.7%200-2.1.1.1-.6.1-1.1.1-1.7-.5.1-1.2.2-1.7.2%200%20.4%200%201.3.1%201.5-.3-.1-1.2-.1-1.6-.1v1.8c.4%200%201.1%200%201.5-.2-.1.8-.2%202.5-.2%203.3%200%201.7.6%202.5%202.2%202.5.6%200%201.2-.1%201.6-.2%200-.3-.1-.6-.1-.9v-.7c-.2%200-.5.1-.8.1-1%200-1.2-.2-1.2-1.3%200-.8-.1-2.2-.2-2.6v-.1c.7.1%201.8.1%202.4.1m-7.9%201.3c-.5-.1-1-.1-1.6-.1-.6%200-1.2%200-1.7.1%200-1.2.6-1.7%201.7-1.7%201.2%200%201.6.5%201.6%201.7m1.8%201.2v-.6c0-2.8-1.2-4-3.3-4-2.2%200-3.5%201.6-3.5%203.9%200%202.4%201.5%203.9%203.8%203.9%201.1%200%202-.3%202.5-.7-.1-.4-.1-1.2-.1-1.5-.6.3-1.4.4-2.3.4-1.2%200-2-.5-2.1-1.6.2.1.8.1%201.4.1zm-8.4-4.3h-2c0%201.2.1%202.5.1%203.8v3.5h2v-3.5c-.2-1.3-.2-2.6-.1-3.8m.1-1.5v-.9-.9h-2.4v1.8h2.4m-3.6%202.1c-.5-.6-1.2-.8-2.1-.8-2.3%200-3.8%201.6-3.8%203.8%200%202.2%201.5%203.9%203.8%203.9.8%200%201.6-.3%202.1-.8-.1-.5-.2-1.2-.2-1.7-.5.4-1.1.6-1.8.6-1.3%200-2.1-.8-2.1-2.1%200-1.2.7-2%202.1-2%20.9%200%201.3.2%201.9.7%200-.7%200-1.3.1-1.6m-8.9%203c0%201.3-.6%202.2-1.9%202.2-1.3%200-1.9-1-1.9-2.2%200-1.3.6-2.1%201.9-2.1%201.3-.1%201.9.7%201.9%202.1m1.8%200c0-2.4-1.5-3.9-3.6-3.9s-3.6%201.5-3.6%203.8c0%202.4%201.4%204%203.6%204%202.1.1%203.6-1.6%203.6-3.9m-8.6%201.5c0-1.2-.6-1.7-1.9-2-1.4-.3-1.5-.4-1.5-.8%200-.5.4-.8%201.4-.8.7%200%201.3.1%201.8.4%200-.6.1-1.2.2-1.6-.5-.4-1.3-.6-2.1-.6-2%200-3.1%201-3.1%202.4%200%201.1.5%201.8%202%202%201.3.2%201.4.3%201.4.8s-.3.8-1.2.8c-.7%200-1.3-.1-1.8-.4%200%20.5-.1%201.1-.1%201.6.5.4%201.3.5%202%20.5%201.8.1%202.9-.8%202.9-2.3m-11.5-3.1c0%20.4-.1.9-.1%201.4v1.1c-.3.4-.7.6-1.5.6-1.1%200-1.7-.7-1.7-1.8s.5-1.8%201.7-1.8c.8.1%201.3.2%201.6.5m1.8-2h-1.4c-.1.2-.1.5-.2.9-.4-.7-.9-1.1-2-1.1-2%200-3.3%201.4-3.3%203.6%200%202%201.4%203.5%203.3%203.5.9%200%201.5-.6%201.8-1.2V84.2c0%201.3-.6%201.8-1.9%201.8-.6%200-1.1-.1-1.6-.2%200%20.5%200%201-.1%201.6.5.3%201.2.4%201.8.4%202.1%200%203.6-1.1%203.6-3.8v-3-3.4M103.4%2083c-.3.4-.7.6-1.4.6-.8%200-1.1-.3-1.1-.8%200-.6.4-.8%201.3-.9.5%200%20.9%200%201.1-.1zm2%201.9c-.1-.7-.2-1.3-.2-1.9v-2.7c0-2.1-1-3-3.1-3-1.2%200-2.1.3-2.6%201.1.1.4.2.9.2%201.5.4-.5%201.1-.8%202.3-.8%201.1%200%201.5.2%201.5%201.1v.4h-.4c-2.6%200-3.8.6-3.8%202.3%200%201.4.9%202.2%202.4%202.2%201.1%200%201.7-.5%202-1.4h.1c0%20.4.1.8.2%201.2h1.4M96%2083c-.3.4-.7.6-1.4.6-.8%200-1.1-.3-1.1-.8%200-.6.4-.8%201.3-.9.5%200%20.9%200%201.1-.1zm1.9%201.9c-.1-.7-.2-1.3-.2-1.9v-2.7c0-2.1-1-3-3.1-3-1.2%200-2.1.3-2.6%201.1.1.4.2.9.2%201.5.4-.5%201.1-.8%202.3-.8%201.1%200%201.5.2%201.5%201.1v.4h-.4c-2.6%200-3.8.6-3.8%202.3%200%201.4.9%202.2%202.4%202.2%201.1%200%201.7-.5%202-1.4h.1c0%20.4.1.8.2%201.2h1.4m-6.8-7.3h-1.9c-.1.7-.4%201.6-.6%202.5-.2%201-.5%202-.6%202.9-.1-.9-.5-2-.8-3.1-.4-1.1-.6-1.8-.8-2.2h-1.6c-.2.4-.4%201.1-.8%202.2-.4%201.2-.7%202.3-.8%203.1-.1-.8-.3-1.8-.6-2.9-.2-.9-.5-1.8-.6-2.5h-1.9c0%20.3.3%201.4%201.2%204.1.5%201.4.8%202.4%201%203.2H84c.1-.3.7-1.7%201.1-2.9.3-.9.5-1.7.6-2.5.1.8.3%201.6.6%202.5.4%201.2%201%202.7%201.1%202.9H89.1c.2-.8.5-1.7%201-3.2.6-2.8%201-3.9%201-4.1%22%20class%3D%22st0%22%20fill%3D%22%231d1d1b%22%2F%3E%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-33.743%2053.81%29%22%20id%3D%22g3755%22%20clip-path%3D%22url%28%23SVGID_2_%29%22%20class%3D%22st3%22%3E%20%20%20%20%20%20%20%20%3Cpath%20id%3D%22path3753%22%20d%3D%22M55%2095c11%200%2020-8.9%2020-20%200-11-8.9-20-20-20-11%200-20%208.9-20%2020%200%2011%209%2020%2020%2020%22%20class%3D%22st0%22%20fill%3D%22%231d1d1b%22%2F%3E%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-33.743%2053.81%29%22%20id%3D%22g3759%22%20clip-path%3D%22url%28%23SVGID_2_%29%22%20class%3D%22st3%22%3E%20%20%20%20%20%20%20%20%3Cpath%20id%3D%22path3757%22%20d%3D%22M61.6%2064.2l3.7%207.7%201.3%2012.6h-7.5v-6.3c0-2.4-1.8-4.3-4.1-4.3s-4.1%202-4.1%204.3v6.3h-7.5l1.3-12.6%203.7-7.7%201.6%206.3%205.1-8.5%205.1%208.6z%22%20fill%3D%22%23fff%22%2F%3E%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

/**
 * @name Offcourse Theme
 * @description default styles for the Offcourse project
 */

var logo$1 = {
  svg: logoSvg$1,
  dimensions: { height: 1, width: 2.8 },
  background: "white"
};
var baseColors$1 = {
  black: "#000000",
  white: "#FFFFFF",
  darkGray: "#3d3d3d",
  mediumGray: "#c0c4c1",
  lightGray: "#f4f6f4",
  yellow: "#E5CF39",
  blue: "#75C7B3",
  green: "#A5CC45",
  red: "#E34D2F"
};

var grayScale$1 = [baseColors$1.white, baseColors$1.lightGray, baseColors$1.mediumGray, baseColors$1.darkGray, baseColors$1.black];

var namedGrayScale$1 = grayScale$1.map(function (value, index) {
  var name = void 0;
  if (index === 0) {
    name = "white";
  } else if (index === grayScale$1.length - 1) {
    name = "black";
  } else {
    name = "gray[" + index + "]";
  }
  return { name: name, value: value };
});

var colors$1 = {
  grayScale: grayScale$1,
  primary: baseColors$1.blue,
  disabled: grayScale$1[2],
  positive: baseColors$1.green,
  warning: baseColors$1.yellow,
  info: baseColors$1.blue,
  negative: baseColors$1.red,
  white: baseColors$1.white,
  black: baseColors$1.black
};

var fonts$1 = {
  base: "Oswald",
  bold: "Oswald",
  accent: "Oswald"
};

var breakpoints$1 = ["30rem", "48rem", "64rem"];

var baseUnit$1 = 16;

var fontSizes$1 = ["0.75rem", "1rem", "1.375rem", "1.75rem"];

var lineHeights$1 = ["1.25rem", "1.375rem", "1.75rem", "1.875rem", "2rem"];

var space$1 = [0, "0.0625rem", "0.125rem", "0.25rem", "0.5rem", "0.75rem", "1rem", "1.5rem", "2rem"];

var borders$1 = [0, "0.0625rem solid", "0.125rem solid"];

var units$1 = {
  sixteenth: "0.0625rem",
  eight: "0.125rem",
  quarter: "0.25rem",
  half: "0.5rem",
  threeQuarter: "0.75rem",
  base: baseUnit$1,
  baseFont: baseUnit$1,
  baseLine: "1.25rem",
  logoHeight: "1.875rem",
  subTitleFont: "1.375rem",
  titleFont: "1.75rem",
  titleHeight: "1.875rem"
};

var globals$1 = "\n  body {\n    margin: 0;\n    padding: 0;\n    top: 0;\n    left: 0;\n    right: 0;\n    background: " + grayScale$1[1] + ";\n    overflow-x: hidden;\n  }\n\n\n  @font-face {  \n    font-family: 'Oswald';  \n    font-style: normal;  \n    font-weight: 400;  \n    src: local('Oswald Regular'), local('Oswald-Regular'), url(https://fonts.gstatic.com/s/oswald/v16/TK3iWkUHHAIjg752GT8D.ttf) format('truetype');\n  }\n    \n  @font-face {  \n    font-family: 'Oswald';  \n    font-style: normal;  \n    font-weight: 700;  \n    src: local('Oswald Bold'), local('Oswald-Bold'), url(https://fonts.gstatic.com/s/oswald/v16/TK3hWkUHHAIjg75-ohoTus9H.ttf) format('truetype');\n  }\n\n  * {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n\n  body {\n    font-family: Oswald;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n  }\n";

var theme$2 = {
  mode: "default",
  breakpoints: breakpoints$1,
  fontSizes: fontSizes$1,
  lineHeights: lineHeights$1,
  space: space$1,
  colors: colors$1,
  logo: logo$1,
  borders: borders$1,
  units: units$1,
  fonts: fonts$1,
  grayScale: grayScale$1,
  globals: globals$1,
  namedGrayScale: namedGrayScale$1
};

/**
 * @name Offcourse Theme
 * @description default styles for the Offcourse project
 */

var logo$2 = {
  svg: logoSvg$1,
  dimensions: { height: 1, width: 2.8 },
  background: "white"
};
var baseColors$2 = {
  black: "#000000",
  white: "#FFFFFF",
  darkGray: "#3d3d3d",
  mediumGray: "#c0c4c1",
  lightGray: "#f4f6f4",
  yellow: "#E5CF39",
  blue: "#75C7B3",
  green: "#A5CC45",
  red: "#E34D2F"
};

var grayScale$2 = [baseColors$2.white, baseColors$2.lightGray, baseColors$2.mediumGray, baseColors$2.darkGray, baseColors$2.black];

var namedGrayScale$2 = grayScale$2.map(function (value, index) {
  var name = void 0;
  if (index === 0) {
    name = "white";
  } else if (index === grayScale$2.length - 1) {
    name = "black";
  } else {
    name = "gray[" + index + "]";
  }
  return { name: name, value: value };
});

var colors$2 = {
  grayScale: grayScale$2,
  primary: baseColors$2.blue,
  disabled: grayScale$2[2],
  positive: baseColors$2.green,
  warning: baseColors$2.yellow,
  info: baseColors$2.blue,
  negative: baseColors$2.red,
  white: baseColors$2.white,
  black: baseColors$2.black
};

var fonts$2 = {
  base: "Philosopher",
  bold: "Philosopher",
  accent: "Philosopher"
};

var breakpoints$2 = ["30rem", "48rem", "64rem"];

var baseUnit$2 = 16;

var fontSizes$2 = ["0.75rem", "1rem", "1.375rem", "1.75rem"];

var lineHeights$2 = ["1.25rem", "1.375rem", "1.75rem", "1.875rem", "2rem"];

var space$2 = [0, "0.0625rem", "0.125rem", "0.25rem", "0.5rem", "0.75rem", "1rem", "1.5rem", "2rem"];

var borders$2 = [0, "0.0625rem solid", "0.125rem solid"];

var units$2 = {
  sixteenth: "0.0625rem",
  eight: "0.125rem",
  quarter: "0.25rem",
  half: "0.5rem",
  threeQuarter: "0.75rem",
  base: baseUnit$2,
  baseFont: baseUnit$2,
  baseLine: "1.25rem",
  logoHeight: "1.875rem",
  subTitleFont: "1.375rem",
  titleFont: "1.75rem",
  titleHeight: "1.875rem"
};

var globals$2 = "\n  body {\n    margin: 0;\n    padding: 0;\n    top: 0;\n    left: 0;\n    right: 0;\n    background: " + grayScale$2[1] + ";\n    overflow-x: hidden;\n  }\n\n  @font-face {  \n    font-family: 'Philosopher';  \n    font-style: normal;  \n    font-weight: 400;  \n    src: local('Philosopher Regular'), local('Philosopher-Regular'), \n    url(https://fonts.gstatic.com/s/philosopher/v9/vEFV2_5QCwIS4_Dhez5jcWBuT0g.ttf) format('truetype');\n  }\n\n  * {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n\n  body {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n  }\n";

var theme$4 = {
  mode: "default",
  breakpoints: breakpoints$2,
  fontSizes: fontSizes$2,
  lineHeights: lineHeights$2,
  space: space$2,
  colors: colors$2,
  logo: logo$2,
  borders: borders$2,
  units: units$2,
  fonts: fonts$2,
  grayScale: grayScale$2,
  globals: globals$2,
  namedGrayScale: namedGrayScale$2
};

export { theme as offcourse, theme$2 as oswald, theme$4 as philosopher };



//////////////////
// WEBPACK FOOTER
// ../themes/dist/index.es.js
// module id = 71
// module chunks = 0